import { CustomValidators } from './../../../shared/validators/custom-validators';
import { StartupService } from './../../../shared/services/startup.service';
import { BaseFormValidation } from './../../../shared/validators/base-form-validation';
import { Router, ActivatedRoute } from '@angular/router';
import { SecurityService } from './../../security.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'online-app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent extends BaseFormValidation implements OnInit {

  protected form:FormGroup;

  constructor(
    private fb:FormBuilder,
    private startupSer:StartupService, 
    protected securityService:SecurityService, 
    private router:Router,
    private route: ActivatedRoute) {
    super();
    this.form=fb.group({
      'newPassword':[null, [Validators.required,CustomValidators.PasswordStrength(this.startupSer.passwordConfig)]],
      'confirmPassword':[null, Validators.required],
      'tempPassword':[null, Validators.required]
    },    
    {
      validator:CustomValidators.MatchPassword
    });
  }

  ngOnInit() {
    const tempPassword=this.route.snapshot.data['tempPassword'];
    if(tempPassword){
      this.form.get('tempPassword').setValue(tempPassword.value);
    }
  }

  protected reset(){
    if(this.form.valid)
    this.securityService.changePassword(this.form.value).subscribe(()=>{
      this.securityService.toastr.success('Password was changed successfully');
      this.router.navigate(['/stages']);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/security/security/reset-password/reset-password.component.ts